export const creditsUnlockTypes = {
  HANDLE_CREDITS_UNLOCK_INPUTS: 'HANDLE_CREDITS_UNLOCK_INPUTS',
  GET_CREDITS_UNLOCK: 'GET_CREDITS_UNLOCK',
  ADD_CREDITS_UNLOCK: 'ADD_CREDITS_UNLOCK',
  CHANGE_STATUS_CREDIT_UNLOCK: 'CHANGE_STATUS_CREDIT_UNLOCK',
  DELETE_CREDITS_UNLOCK: 'DELETE_CREDITS_UNLOCK',
  CHECK_CREDIT_UNLOCK_SETTINGS: 'CHECK_CREDIT_UNLOCK_SETTINGS',
  CLEAN_EXISTS: 'CLEAN_EXISTS',
  RESTORE_INITIAL: "RESTORE_INITIAL",
};